import { Button } from 'primereact/button'
import  { useEffect, useState } from 'react'
import imagineHomeService from "../imagineHomeService";
import { DataTable } from 'primereact/datatable';
import { Column } from "primereact/column";
import * as XLSX from "xlsx";
import { superAdmin } from "../../../lib/constants";

const SupplierReports = () => {
    const [suppliersReports, setSuppliersReports] = useState([]);
    const [first, setFirst] = useState(0);
    const [skip, setSkip] = useState(0);
    const suppliersLimit = 20,
        rows = 10;

    const userpermissions = JSON.parse(localStorage.getItem("permissions"))
    const isAdmin = (userpermissions.includes(superAdmin))

    useEffect(() => {
        getData(0, suppliersLimit);
    }, [])

    const getData = (skip = 0, lim, searchQuery = '') => {
        imagineHomeService.getSuppliersReportsData({
            skip: skip,
            limit: lim,
            searchQuery: searchQuery
        })
            .then((res) => {
                if (Array.isArray(res)) {
                    setSuppliersReports(res);
                }
            })
            .catch((e) => {
                console.error(e);
            });
    }

    const onDownload = async () => {
        let Data = [];
        const res = await imagineHomeService.getSuppliersReportsData({
            skip: 0,
            limit: 0,
            searchQuery: ''
        })
        res.map((item) => {
            let obj = {};
            obj["Supplier Id"] = item.vendorId;
            obj["DBA/Brand Name"] = item.brandName;
            obj["EIN"] = item.ein;
            obj["Entity Type"] = item.entityType;
            obj["State of Incorporation/Formation"] = item.formationState;
            obj["Business Legal Name"] = item.businessLegalName;
            obj["Primary Contact Name"] = item.supplierInfo.name;
            obj["Primary Contact Email Address"] = item.supplierInfo.email;
            obj["Primary Contact Mobile Number"] = item.supplierInfo.mobile;
            obj["Title/Role"] = item.supplierInfo.role;
            obj["Address"] = item.businessAddress.street;
            obj["State"] = item.businessAddress.state;
            obj["City"] = item.businessAddress.city;
            obj["Zip"] = item.businessAddress.zip;
            obj["Country"] = item.businessAddress.country;
            Data.push(obj);
        });
        let filename = "suppliers_report.xlsx";
        let ws = XLSX.utils.json_to_sheet(Data);
        let wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
        XLSX.writeFile(wb, filename);
    };

    const handleFilter = async (skipCount = 0) => {
        try {
            let resp = await imagineHomeService.getSuppliersReportsData({ skip: skipCount, limit: suppliersReports.length });
            if (resp.length < suppliersLimit) setSkip(-1);
            setSuppliersReports((prev) => {
                const merged = [...prev, ...resp];
                return merged;
            });
        } catch (error) {
        } finally {
        }
    };
    if(!isAdmin) return (<div className="col-12 " style={{ color: "#01579B" }}>
      <div className="card flex flex-column align-items-center justify-content-center dijon-ivory" style={{ height: "60vh"}}>
          <span className="fa-solid fa-circle-info" style={{ fontSize: "3rem" }}></span>
          <h3 className='font-larken'>You are not authorized to access this page</h3>
      </div>
  </div>) 
    return (
        <div className='' style={{ fontFamily: "Inter", backgroundColor: "#FBF9F3" }}>
            <div className="p-0 col-12 flex justify-content-end flex-wrap">
                <h2 className="item-Header m-0 charcoal-color col-12 sm:col-6">Suppliers Registration Report</h2>
                <div className="col-12 sm:col-6">
                    <Button label="Download" icon="pi pi-download" onClick={onDownload} className=""  style={{
                                    fontFamily:"Inter",
                                    background: "white",
                                    float: "right",
                                    height: "40px",
                                    boxShadow: '0 6px 8px -4px rgba(0, 0, 0, 0.15)',
                                    border: "1px solid #ddd",
                                    color: "#3d3d3d",
                                    borderRadius: "20px",
                                    padding: "10px 20px",
                                    whiteSpace: "nowrap"

                                }} />
                </div>
            </div>
            <div className="col-12 mt-2 "  style={{ fontFamily: "Inter", backgroundColor: "#FBF9F3" }}>
                <DataTable value={suppliersReports} 
                    paginator={true}
                    first={first}
                    rows={rows}
                    className="w-full card-table"
                    rowClassName={() => 'card-row'}
                    onPage={async (e) => {
                        const totalPages = Math.ceil(suppliersReports.length / rows);
                        if (e.page === totalPages - 1 && skip !== -1) {
                            const newSkip = suppliersReports.length;
                            setSkip(newSkip);
                            await handleFilter(newSkip);
                        }
                        setFirst(e.first);
                    }}
                    responsiveLayout="scroll">
                    <Column header="Supplier Id" bodyClassName="text-lg p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" field="vendorId" style={{minWidth:"200px"}}></Column>
                    <Column header="DBA/Brand Name" bodyClassName="text-lg p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" field="brandName" style={{minWidth:"200px"}}></Column>
                    <Column header="EIN" bodyClassName="text-lg p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" field="ein"></Column>
                    <Column header="Entity Type" bodyClassName="text-lg p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" field="entityType" style={{minWidth:"200px"}}></Column>
                    <Column header="State of Incorporation/Formation" bodyClassName="text-lg p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" field="formationState" style={{minWidth:"250px"}}></Column>
                    <Column header="Business Legal Name" bodyClassName="text-lg p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" field="businessLegalName" style={{minWidth:"200px"}}></Column>
                    <Column header="Primary Contact Name" bodyClassName="text-lg p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" field="supplierInfo.name" style={{minWidth:"200px"}}></Column>
                    <Column header="Primary Contact Number" bodyClassName="text-lg p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" field="supplierInfo.mobile" style={{minWidth:"200px"}}></Column>
                    <Column header="Primary Contact Email" bodyClassName="text-lg p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" field="supplierInfo.email" style={{minWidth:"200px"}}></Column>
                    <Column header="Title / Role" bodyClassName="text-lg p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" field="supplierInfo.role" style={{minWidth:"200px"}}></Column>
                    <Column header="Address" bodyClassName="text-lg p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" field="businessAddress.street" style={{minWidth:"200px"}}></Column>
                    <Column header="State" bodyClassName="text-lg p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" field="businessAddress.state" ></Column>
                    <Column header="City" bodyClassName="text-lg p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" field="businessAddress.city" ></Column>
                    <Column header="Zip" bodyClassName="text-lg p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" field="businessAddress.zip" ></Column>
                    <Column header="Country" bodyClassName="text-lg p-2 font-Gerstner-ProgramRegular" headerClassName="dataTableHeader" field="businessAddress.country" ></Column>
                </DataTable>
            </div>
        </div>
    )
}

export default SupplierReports